export default __webpack_public_path__ + "static/media/Meals4MeTagLine.e27fedc2.png";